import {BaseContainerModel} from '../base-container.model';
import {bl_sys_vendor_hdr_RowClass} from '../../dbschema/bl_sys_vendor_hdr.model';
import {bl_sys_vendor_ext_RowInterface} from '../../dbschema/bl_sys_vendor_ext.model';

export class VendorContainerModel extends BaseContainerModel {
  bl_sys_vendor_hdr: bl_sys_vendor_hdr_RowClass = new bl_sys_vendor_hdr_RowClass();
  bl_sys_vendor_ext: Array<bl_sys_vendor_ext_RowInterface> = [];
}
